import { call, put, takeLatest } from 'redux-saga/effects'
import { showLoader, hideLoader } from '../slices/loader.slice'
import { SagaIterator } from 'redux-saga'
import {
  filterCorrespondenceLogsData,
  getPreviewCorrespondenceDataView,
  updateCorrespondenceFilterData,
  updateSelectedCorrespondenceLogState,
  updateTotalPagesCorrespondenceLogs,
} from '../slices/correspondenceLogs.slice'
import { GetAllCorrespondenceLogsAction } from '../types/correspondenceLogs.types'
import {
  fetchAllCorrespondenceTemplateApi,
  filterAllCorrespondenceLogsApi,
} from '../apis/correspondenceLogs.api'
import { PayloadAction } from '@reduxjs/toolkit'
import { addToaster } from '../slices'
import { previewTemplatePayloadType } from '../types/manualCommunication.types'

// filter function
function* filterAllCorrespondenceLogs(
  action: GetAllCorrespondenceLogsAction
): SagaIterator {
  try {
    yield put(showLoader())
    const response = yield call(filterAllCorrespondenceLogsApi, action.payload)
    yield put(
      updateCorrespondenceFilterData({
        ...response.data.dataTPage,
        option: response.data?.filtered,
      })
    )
    yield put(
      updateTotalPagesCorrespondenceLogs(response.data?.dataTPage.totalPages)
    )
    if (action?.toastSettings) {
      yield put(addToaster(action?.toastSettings))
    }
  } catch (err) {
    console.error(err)
  } finally {
    yield put(hideLoader())
  }
}
// preview function
function* fetchPreviewCorrespondenceTemplateData(
  action: PayloadAction<previewTemplatePayloadType>
): SagaIterator {
  try {
    yield put(showLoader())
    const response = yield call(
      fetchAllCorrespondenceTemplateApi,
      action.payload
    )
    yield put(updateSelectedCorrespondenceLogState(response.data))
  } catch (err) {
    console.error(err)
  } finally {
    yield put(hideLoader())
  }
}

export function* watchFilterAllCorrespondenceLogs() {
  yield takeLatest(
    filterCorrespondenceLogsData.type,
    filterAllCorrespondenceLogs
  )
}

export function* watchFetchPreviewCorrespondenceData() {
  yield takeLatest(
    getPreviewCorrespondenceDataView.type,
    fetchPreviewCorrespondenceTemplateData
  )
}
